
// import React, { useEffect, useState } from 'react'
// import { Button, Col, Container, Row } from 'react-bootstrap'
// import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
// import HomeTitle from "../components/HomeTitle/HomeTitle"
// import { useSelector } from 'react-redux';
// import ExportBox from "../components/ExportBox/ExportBox"
// import Table from "../components/Table/Table"
// import Select from 'react-select';
// import axios from 'axios';
// import Paginations from './Paginations';
// import CustomModel from '../components/CustomModel/CustomModel';

// function Finance() {
//   const userinfo = useSelector((state) => state);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [paginationsItems, setPaginationsItems] = useState(null)
//   const [total, setTotal] = useState("");
//   const [modalShow, setModalShow] = React.useState(false);
//   const [acceotRejectId, setAcceotRejectId] = useState('')
//   const [statusPending, setstatusPending] = useState(false);
//   const [is_registration_fee, setIs_registration_fee] = useState(null);

//   const options = [
//     { label: "الابتدائي", value: 'first' },
//     { label: "الاعدادي", value: 'second' },
//     { label: "الثانوي", value: 'third' },
//   ];
//   const gradoptions = [
//     { label: "الصف الاول", value: 'first' },
//     { label: "الصف الثاني", value: 'second' },
//     { label: "الصف الثالث", value: 'third' },
//   ];
//   const classoptions = [
//     { label: "تقسيط", value: 'first' },
//     { label: "كاش", value: 'second' },
//   ];

//   const { currentLocal } = useSelector((state) => state.currentLocal);
//   const [items, setItems] = useState([])

//   const headerIterm = [
//     currentLocal.home.ID,
//     currentLocal.home.namePlaceholder,
//     currentLocal.home.Total,
//     currentLocal.home.image,
//     currentLocal.home.stageName,
//     currentLocal.home.grade,

//     currentLocal.home.method,

//     currentLocal.home.PaidPrice,
//     currentLocal.home.RemainingPrice,
//     currentLocal.home.date,
//     currentLocal.home.status,
//     // currentLocal.home.phone,





//   ]
//   const getData = async () => {
//     try {
//       const response = await axios.get(
//         `https://nanosoft.space/taarteb/public/api/admin/student-expenses`,
//         {
//           headers: {
//             Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//           },
//         }
//       );

//       setPaginationsItems(response.data)
//         console.log(response.data.data.student_expenses?.data.length);

//       const totalData = response.data.data.student_expenses?.data
//       setItems(totalData);

//       const accepted = totalData.filter((item) => item?.status == "accepted")
      
//       const total = accepted.reduce((sum, item) => {
//         return sum + (Number(item?.amount_paid) || 0);
//       }, 0);
      
//       setTotal(total)
//       // const total = response.data.data.reduce((sum, item) => sum + (item.amount_paid || 0), 0);



//     } catch (error) {

//     }
//   }
//   useEffect(() => {
//     getData()
//   }, [currentPage])
//   const printTable = () => {
//     const content = document.getElementById("financialTable").innerHTML;

//     const printWindow = window.open("", "_blank", "width=900,height=700");
//     printWindow.document.write(`
//     <html dir="rtl">
//       <head>
//         <title>${currentLocal.home.FinanceReport}</title>
//         <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
//         <style>
//           body {
//             font-family: Arial, sans-serif;
//             direction: rtl;
//             padding: 20px;
//           }
//           .fw-bold {
//             font-weight: bold;
//           }
//           table {
//             width: 100%;
//             border-collapse: collapse;
//             margin-top: 20px;
//           }
//           table, th, td {
//             border: 1px solid #000;
//           }
//           th, td {
//             padding: 8px;
//             text-align: center;
//           }
//           th {
//             background-color: #f8f8f8;
//           }
//         </style>
//       </head>
//       <body>
//         ${content}
//       </body>
//     </html>
//   `);
//     printWindow.document.close();
//     printWindow.focus();
//     printWindow.print();
//   };
//   const body = <tbody>
//     {items?.map((item, index) => {

//       return (
//         <tr key={index}>

//           <td>{item?.id}</td>
//           <td>{item?.student?.name}</td>
//           <td>{item?.expense_price}{" "}{currentLocal.home.currancy}</td>

//           <td><img src={item?.receipt} alt='' className='w-100' /></td>
//           <td>{item?.grade_category?.name} </td>

//           <td>{item?.grade?.name} </td>


//           {item?.payment_method && <td>{item.payment_method == "1" ? currentLocal.home.Cash : currentLocal.home.visa}</td>}
//           <td>{item?.amount_paid}{" "}{currentLocal.home.currancy}</td>
//           <td>{item?.amount_due}{" "}{currentLocal.home.currancy}</td>

//           <td>{item?.created_at.slice(0, 10)}</td>
//           <td>{item.status == "accepted" ? currentLocal.home.accept : item.status == "pending" ? currentLocal.home.pending : currentLocal.home.reject}
            
//           </td>
//           <td>
//             {item?.status !== "accepted" &&
//               <div className='d-flex'>
//                 <Button className='mx-3'
//                   onClick={() => {
//                     setModalShow(true);
//                     setAcceotRejectId(item?.id)
//                     setstatusPending('accept')
//                     setIs_registration_fee("")

//                   }}
//                 >{currentLocal.home.accept}</Button>
//                 <Button variant="danger" onClick={() => {
//                   setModalShow(true);
//                   setAcceotRejectId(item?.id)
//                   setstatusPending('reject')
//                 }}>{currentLocal.home.reject}</Button>
//               </div>
//             }
//           </td>
//         </tr>
//       )
//     })}

//   </tbody>




//   return (
//     <div className="px-0 my-3 w-100 dashboard_content">
//       <Container>
//         <CustomModel
//           show={modalShow}
//           onHide={() => setModalShow(false)}
//           status={statusPending}
//           acceptStatus={'student-expenses'}
//           id={acceotRejectId}
//           is_registration_fee={is_registration_fee}
//         />
//         <div className="d-flex flex-column w-100">

//           <AuthNavbar />
//           <div className="mt-5 mx-3">
//             <HomeTitle title={currentLocal.home.Finance} />


//             <p className="w-100  fw-bold"> {currentLocal.home.Finance}:{Number(total)} {currentLocal.home.currancy}</p>
//             <p className='mb-5 fw-bold '>{currentLocal.home.Paycustomerdata}</p>

//             <Row className='mb-5'>
//               {/* <Col md={3}>
//                             <div>
//                                 <div className='mb-3'>
//                                     <Select
//                                         value={grade_id}
//                                         onChange={(selectedOption) => setGrade_id(selectedOption)}
//                                         options={options}
//                                         placeholder={currentLocal.home.stageName} // Change this text

//                                     />
//                                 </div>
//                             </div>
//                         </Col>
//                                 <Col md={3}>
//                             <div>
//                                 <div className='mb-3'>
//                                     <Select
//                                         value={type_id}
//                                         onChange={(selectedOption) => setType_id(selectedOption)}
//                                         options={gradoptions}
//                                         placeholder={currentLocal.home.grade} // Change this text

//                                     />
//                                 </div>
//                             </div>
//                         </Col> */}
//               {/* <Col md={3}>
//                             <div>
//                                 <div className='mb-3'>
//                                     <Select
//                                         value={class_id}
//                                         onChange={(selectedOption) => setClass_id(selectedOption)}
//                                         options={classoptions}
//                                         placeholder={currentLocal.home.type} // Change this text

//                                     />
//                                 </div>
//                             </div>
//                         </Col> */}

//             </Row>
//             <Row>
//               <div>
//                 <button onClick={printTable} className="btn  border mb-3 mt-3">
//                   <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
//                     <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
//                     <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
//                   </svg>
//                 </button>
//               </div>

//             </Row>
//             <div id="financialTable">

//               <Table
//                 body={body}
//                 headerIterm={headerIterm}
//                 // onDataChanged={getAllApis}
//                 actions={localStorage.getItem("type") !== "student" ? ["acceptOrReject"] : [""]}
//                 acceptStatus={'student-expenses'}

//               />
//               <Paginations
//                 total={paginationsItems?.last_page}
//                 currentPage={currentPage}
//                 onPageChange={(page) => setCurrentPage(page)}
//               />
//             </div>
//           </div>

//         </div>
//       </Container>
//     </div>)
// }

// export default Finance

import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row, Modal } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"
import Select from 'react-select';
import axios from 'axios';
import Paginations from './Paginations';
import CustomModel from '../components/CustomModel/CustomModel';

function Finance() {
  const userinfo = useSelector((state) => state);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationsItems, setPaginationsItems] = useState(null)
  const [total, setTotal] = useState("");
  const [modalShow, setModalShow] = React.useState(false);
  const [acceotRejectId, setAcceotRejectId] = useState('')
  const [statusPending, setstatusPending] = useState(false);
  const [is_registration_fee, setIs_registration_fee] = useState(null);

  // States for Image Modal & Downloading
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [downloading, setDownloading] = useState(false);

  const options = [
    { label: "الابتدائي", value: 'first' },
    { label: "الاعدادي", value: 'second' },
    { label: "الثانوي", value: 'third' },
  ];
  const gradoptions = [
    { label: "الصف الاول", value: 'first' },
    { label: "الصف الثاني", value: 'second' },
    { label: "الصف الثالث", value: 'third' },
  ];
  const classoptions = [
    { label: "تقسيط", value: 'first' },
    { label: "كاش", value: 'second' },
  ];

  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [items, setItems] = useState([])

  const headerIterm = [
    currentLocal.home.ID,
    currentLocal.home.namePlaceholder,
    currentLocal.home.Total,
    currentLocal.home.image,
    currentLocal.home.stageName,
    currentLocal.home.grade,
    currentLocal.home.method,
    currentLocal.home.PaidPrice,
    currentLocal.home.RemainingPrice,
    currentLocal.home.date,
    currentLocal.home.status,
  ]

  const getData = async () => {
    try {
      const response = await axios.get(
        `https://nanosoft.space/taarteb/public/api/admin/student-expenses`,
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );

      setPaginationsItems(response.data)
      const totalData = response.data.data.student_expenses?.data
      setItems(totalData);

      const accepted = totalData.filter((item) => item?.status == "accepted")
      
      const total = accepted.reduce((sum, item) => {
        return sum + (Number(item?.amount_paid) || 0);
      }, 0);
      
      setTotal(total)
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getData()
  }, [currentPage])

  // Function to download image safely
  const handleDownloadImage = async (imgUrl) => {
    try {
      setDownloading(true);
      const response = await fetch(imgUrl, { mode: 'cors' });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = blobUrl;
      // Extract file extension or default to jpg
      const extension = imgUrl.split('.').pop().split(/\#|\?/)[0] || 'jpg';
      link.download = `receipt_${Date.now()}.${extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed, opening in new tab instead", error);
      window.open(imgUrl, '_blank');
    } finally {
      setDownloading(false);
    }
  };

  const printTable = () => {
    const content = document.getElementById("financialTable").innerHTML;

    const printWindow = window.open("", "_blank", "width=900,height=700");
    printWindow.document.write(`
    <html dir="rtl">
      <head>
        <title>${currentLocal.home.FinanceReport}</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
        <style>
          body {
            font-family: Arial, sans-serif;
            direction: rtl;
            padding: 20px;
          }
          .fw-bold {
            font-weight: bold;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          table, th, td {
            border: 1px solid #000;
          }
          th, td {
            padding: 8px;
            text-align: center;
          }
          th {
            background-color: #f8f8f8;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const body = <tbody>
    {items?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item?.id}</td>
          <td>{item?.student?.name}</td>
          <td>{item?.expense_price}{" "}{currentLocal.home.currancy}</td>

          {/* Clickable Image cell */}
          <td>
            {item?.receipt ? (
              <img 
                src={item?.receipt} 
                alt='receipt' 
                className='w-100' 
                style={{ cursor: 'pointer', maxHeight: '60px', objectFit: 'contain' }}
                onClick={() => {
                  setSelectedImage(item?.receipt);
                  setShowImageModal(true);
                }} 
              />
            ) : (
              "-"
            )}
          </td>

          <td>{item?.grade_category?.name} </td>
          <td>{item?.grade?.name} </td>
          {item?.payment_method && <td>{item.payment_method == "1" ? currentLocal.home.Cash : currentLocal.home.visa}</td>}
          <td>{item?.amount_paid}{" "}{currentLocal.home.currancy}</td>
          <td>{item?.amount_due}{" "}{currentLocal.home.currancy}</td>
          <td>{item?.created_at.slice(0, 10)}</td>
          <td>{item.status == "accepted" ? currentLocal.home.accept : item.status == "pending" ? currentLocal.home.pending : currentLocal.home.reject}</td>
          <td>
            {item?.status !== "accepted" &&
              <div className='d-flex'>
                <Button className='mx-3'
                  onClick={() => {
                    setModalShow(true);
                    setAcceotRejectId(item?.id)
                    setstatusPending('accept')
                    setIs_registration_fee("")
                  }}
                >{currentLocal.home.accept}</Button>
                <Button variant="danger" onClick={() => {
                  setModalShow(true);
                  setAcceotRejectId(item?.id)
                  setstatusPending('reject')
                }}>{currentLocal.home.reject}</Button>
              </div>
            }
          </td>
        </tr>
      )
    })}
  </tbody>

  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <Container>
        <CustomModel
          show={modalShow}
          onHide={() => setModalShow(false)}
          status={statusPending}
          acceptStatus={'student-expenses'}
          id={acceotRejectId}
          is_registration_fee={is_registration_fee}
        />

        {/* Image Preview & Download Modal */}
        <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>معاينة الإيصال</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <img src={selectedImage} alt="Large Receipt" className="img-fluid rounded mb-3" style={{ maxHeight: '70vh' }} />
          </Modal.Body>
          <Modal.Footer>
            <Button 
              variant="success" 
              onClick={() => handleDownloadImage(selectedImage)}
              disabled={downloading}
            >
              {downloading ? 'جاري التحميل...' : 'تحميل الصورة (Download)'}
            </Button>
            <Button variant="secondary" onClick={() => setShowImageModal(false)}>
              إغلاق
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="d-flex flex-column w-100">
          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.Finance} />

            <p className="w-100 fw-bold"> {currentLocal.home.Finance}:{Number(total)} {currentLocal.home.currancy}</p>
            <p className='mb-5 fw-bold '>{currentLocal.home.Paycustomerdata}</p>

            <Row>
              <div>
                <button onClick={printTable} className="btn border mb-3 mt-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
                    <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                    <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                  </svg>
                </button>
              </div>
            </Row>

            <div id="financialTable">
              <Table
                body={body}
                headerIterm={headerIterm}
                actions={localStorage.getItem("type") !== "student" ? ["acceptOrReject"] : [""]}
                acceptStatus={'student-expenses'}
              />
              <Paginations
                total={paginationsItems?.last_page}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Finance;